// assets/notify-me-super.js
document.addEventListener('DOMContentLoaded', () => {
  const root = document.getElementById('notify-me-root');
  if (!root) return;

  const form = document.getElementById('emailNotificationForm');
  const email = form?.querySelector('#emailInput');
  const messageEl = form?.querySelector('#formMessage');
  const submitBtn = form?.querySelector('.notify-button');
  const variantIdInput = form?.querySelector('#notify-variant-id');
  const consentEl = document.getElementById('notify-consent');

  // Defensive guards
  if (!form || !email || !messageEl || !submitBtn || !variantIdInput) return;

  // Config from data-attrs
  const onlyOOS = root.dataset.onlyOos === 'true';
  const endpoint = root.dataset.endpoint || '/apps/notify-me';
  const successCopy = root.dataset.success || "You’re on the list. We’ll email you when it’s back.";
  const errorCopy = root.dataset.error || "Something went wrong. Please try again.";
  const requireConsent = root.dataset.requireConsent === 'true';
  const oosCopy = root.dataset.copyOos || "Currently this product is out of stock. Be the first to be notified.";

  // ---------- Product JSON (robust finder) ----------
  let productData = null;
  (function findProductJson() {
    const scope = root.closest('[data-section]') || document;
    const candidates = [
      '[type="application/json"][data-product]',
      'script[type="application/json"][id^="ProductJson-"]',
      'script[type="application/json"][id^="ProductJSON-"]'
    ];
    for (const sel of candidates) {
      const el = scope.querySelector(sel) || document.querySelector(sel);
      if (!el) continue;
      try {
        const parsed = JSON.parse(el.textContent);
        if (parsed?.variants?.length) { productData = parsed; return; }
      } catch (_) {}
    }
  })();

  function getSelectedVariant() {
    // Theme global (some themes set this)
    if (window?.Shopify?.theme?.selectedVariant) return window.Shopify.theme.selectedVariant;

    if (!productData?.variants?.length) return null;

    // By selected options
    const selects = Array.from(document.querySelectorAll('select[name^="options"]'));
    const radios  = Array.from(document.querySelectorAll('input[type="radio"][name^="options"]:checked'));
    const chosen  = (selects.length ? selects.map(s => s.value) : radios.map(r => r.value));

    if (chosen.length) {
      const byOptions = productData.variants.find(v => v.options.every((opt, i) => opt == chosen[i]));
      if (byOptions) return byOptions;
    }

    // Hidden id input synced by most themes
    const idInput = document.querySelector('form[action*="/cart/add"] input[name="id"]');
    if (idInput) {
      const byId = productData.variants.find(v => String(v.id) === String(idInput.value));
      if (byId) return byId;
    }

    // Selected or first
    if (productData.selected_or_first_available_variant) {
      const bySel = productData.variants.find(v => v.id === productData.selected_or_first_available_variant.id);
      if (bySel) return bySel;
    }

    return productData.variants[0] || null;
  }

  // ---------- UI helpers ----------
  function setLoading(state) {
    submitBtn.classList.toggle('loading', state);
    submitBtn.disabled = state;
  }

  function showMessage(type, text) {
    messageEl.className = `message ${type === 'success' ? 'success-message' : 'error-message'} show`;
    messageEl.textContent = text;
    window.clearTimeout(showMessage._t);
    showMessage._t = window.setTimeout(() => {
      messageEl.classList.remove('show');
    }, 5000);
  }

  function validEmail(value) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
  }

function refreshVisibility() {
  const v = getSelectedVariant();
  if (!v) return;

  variantIdInput.value = v.id;
  const out = !v.available; // <-- computed

  // NEW: hide/show the buy buttons block
  const buyWrapper = document.getElementById('buy-buttons-wrapper');
  if (buyWrapper) {
    buyWrapper.style.display = out ? 'none' : '';
  }

  // Toggle Notify Me visibility when set to OOS-only
  if (onlyOOS) root.classList.toggle('hidden', !out);

  // Keep heading copy in sync
  const heading = document.getElementById('notify-heading');
  if (heading) heading.textContent = oosCopy;
}


  // Initial toggle + listeners
  document.addEventListener('variant:change', refreshVisibility);
  document.addEventListener('change', (e) => {
    if (e.target.matches('select[name^="options"], input[name^="options"]')) refreshVisibility();
  });
  refreshVisibility();

  // ---------- Submit ----------
  form.addEventListener('submit', async (e) => {
    e.preventDefault();

    const v = getSelectedVariant();

    // If variant flipped in stock while visible, hide
    if (v && v.available && onlyOOS) {
      root.classList.add('hidden');
      return;
    }

    const emailVal = email.value.trim();
    if (!validEmail(emailVal)) {
      email.classList.add('error');
      showMessage('error', 'Please enter a valid email address');
      email.focus();
      return;
    }
    if (requireConsent && !consentEl?.checked) {
      showMessage('error', 'Please confirm consent to be contacted');
      return;
    }

    setLoading(true);

    const payload = {
      shop: root.dataset.shopDomain,
      product_id: root.dataset.productId,
      product_title: root.dataset.productTitle,
      product_handle: root.dataset.productHandle,
      variant_id: v ? String(v.id) : null,
      variant_title: v ? v.title : null,
      options: v ? v.options : null,
      url: form.querySelector('input[name="url"]')?.value || location.href,
      email: emailVal,
      consent: !!consentEl?.checked,
      utm: Object.fromEntries(new URLSearchParams(location.search)),
      ts: new Date().toISOString(),
      customer_id: window?.Shopify?.customer?.id || null,
      locale: document.documentElement.lang || 'en'
    };

    try {
      const res = await fetch(endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      });

      if (res.ok) {
        showMessage('success', successCopy);
        form.reset();
        email.classList.remove('error');
        window.dispatchEvent(new CustomEvent('notify_me_success', { detail: payload }));
      } else {
        showMessage('error', errorCopy);
        window.dispatchEvent(new CustomEvent('notify_me_error', { detail: { status: res.status } }));
      }
    } catch (err) {
      showMessage('error', errorCopy);
      window.dispatchEvent(new CustomEvent('notify_me_error', { detail: { error: String(err) } }));
    } finally {
      setLoading(false);
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: 'notify_me_submitted', ...payload });
    }
  });

  // Input UX
  email.addEventListener('input', () => {
    email.classList.remove('error');
    if (messageEl.classList.contains('error-message')) messageEl.classList.remove('show');
  });
});
